// extracted by mini-css-extract-plugin
export default {"root":"Root_root__kT5Fk","header":"Root_header__jKRCD","content":"Root_content__3BTU5","sider":"Root_sider__tgxIc"};